var publicPath = __webpack_public_path__;
                    var symbolUrl = 'svg/icons.svg#slack-colorful';
                    var viewUrl = 'svg/icons.svg#view-slack-colorful';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '50 50 170 170',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };